export const endPoint = {
  development: "https://be.cicinhakhanh.com/api",
  production: "https://be.cicinhakhanh.com/api",

  // development: "http://localhost:8000/api",
  // production: "http://localhost:8000/api",
};
